import { render, staticRenderFns } from "./goods-bindInfo.vue?vue&type=template&id=6431d348&scoped=true&"
import script from "./goods-bindInfo.vue?vue&type=script&lang=js&"
export * from "./goods-bindInfo.vue?vue&type=script&lang=js&"
import style0 from "./goods-bindInfo.vue?vue&type=style&index=0&id=6431d348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431d348",
  null
  
)

export default component.exports